import React, { useRef, useState } from 'react';
import { Button, Row, Col, Table, Label } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tag } from 'primereact/tag';
import '../../../micro/cotizacion/SyleQuoterMic/styleSearchQuoter.css'
export const TableListQuoterMic = (props) => {

	const {
		handleNavigateSampling, loadingCreate, getSearchQuoter,
		downdloadpdfSampling,
		navigateUpdate, navigateIngress, PreviewQuoter,
		setActiveIndex, informationQuatation


	} = props;

	const [selectedQuotation, setSelectedQuotation] = useState(null);
	const op = useRef(null);
	const [expandedRows, setExpandedRows] = useState(null);
	console.log("🍏 informationQuatation", informationQuatation);


	const codeTemplate = (rowData) => (

		<div
			style={{
				backgroundColor: "#f97316",
				width: "90px",
				height: "20px",
				borderRadius: "8px",
				color: "#fff",
				fontSize: "10px",
				paddingTop: "1px",
				margin: "auto"
			}}
		>
			<label
				className="f-w-600"
				style={{ fontSize: "10px" }}
			>
				{rowData?.code_quoter ?? "------"}
			</label>
		</div>

	);

	const typeTemplate = (rowData) => {

		const isCompany = rowData?.type === "Empresa";
		return (
			<span
				style={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					minWidth: "90px",
					padding: "4px 12px",
					borderRadius: "20px",
					fontSize: "11px",
					fontWeight: "700",
					letterSpacing: ".3px",
					color: isCompany ? "#0d47a1" : "#2e7d32",
					backgroundColor: isCompany ? "#e3f2fd" : "#e8f5e9",
					border: `1px solid ${isCompany ? "#90caf9" : "#a5d6a7"}`
				}}
			>
				<i
					className={`fa ${isCompany ? "fa-building" : "fa-user"}`}
					style={{ marginRight: "6px" }}
				/>
				{isCompany ? "Empresa" : "Particular"}
			</span>
		);

	};

	const clientTemplate = (rowData) => (

		<label
			style={{
				color: "#6c757d",
				fontSize: "12px"
			}}
			className="f-w-600"
		>
			{rowData?.client ?? "------"}
		</label>

	);

	const dateTemplate = (rowData) => (

		<label
			style={{
				color: "#6c757d",
				fontSize: "12px"
			}}
			className="f-w-600"
		>
			{rowData?.date_quoter ?? "------"}
		</label>

	);

	const ivaTemplate = (rowData) => {

		const is16 = rowData?.tax === "16%";

		return (
			<span
				style={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					minWidth: "70px",
					height: "28px",
					borderRadius: "30px",
					fontSize: "11px",
					fontWeight: "700",
					color: "#fff",
					background: is16
						? "linear-gradient(135deg,#ff9800,#f89400)"
						: "linear-gradient(135deg,#00acc1,#2a8490)",
					boxShadow: "0 3px 8px rgba(0,0,0,.15)"
				}}
			>
				<i
					className="fa fa-percent"
					style={{ marginRight: "6px" }}
				/>
				{rowData?.tax ?? "0%"}
			</span>
		);

	};



	// * date sampling

	const dateSampling = (rowData) => {
		const _is_sampling = rowData?.date_sample != null;

		return (
			<span
				style={{
					display: "inline-flex",
					alignItems: "center",
					gap: "6px",
					fontSize: "12px",
					fontWeight: "600",
					color: _is_sampling ? "#198754" : "#dc3545"
				}}
			>
				<i
					className={
						_is_sampling
							? "fa fa-check-circle"
							: "fa fa-times-circle"
					}
					style={{ fontSize: "15px" }}
				/>
			</span>
		);
	};

	const dateTemplate2 = (rowData) => (

		<label
			style={{
				color: "#6c757d",
				fontSize: "12px"
			}}
			className="f-w-600"
		>
			{rowData?.date_sample ?? ""}
		</label>

	);


	const actionsTemplate = (rowData, options) => {

		return (
			<>
				<div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>

					{
						rowData.id_work_order === null ?

							<Button
								size="sm"
								onClick={async () => {
									await getSearchQuoter(
										rowData.code_quoter
									);
									setActiveIndex(
										rowData.type === "Empresa"
											? 2
											: 1
									);
								}}
								title={"Editar cotización"}
								className="btnTableAction"
							>
								<i className="fa fa-edit iconTableAction"></i>
							</Button>


							:

							<>
								<button
									onClick={(e) => {
										setSelectedQuotation(rowData);
										op.current.toggle(e);
									}}
									title="Edición y recepción"
									className="btnTableAction"
									style={{
										backgroundColor: "#0f0f0f"
									}}
								>
									<i className="fa fa-ticket"></i>
								</button>

								<OverlayPanel ref={op} showCloseIcon >
									<div style={{ padding: "10px" }}>
										<h6>Nim asociado a cotización</h6>
										<label className="txt-success f-w-600">
											{selectedQuotation?.nim}
										</label>
										<Col sm="12" className='pt-2' >
											<Row>
												<Col sm="6">
													<Tag onClick={() => navigateUpdate(rowData?.id_work_order)} className="mr-2 pointer" icon="pi pi-file-edit" severity="success" value="Edición"></Tag>
												</Col>
												<Col sm="6">
													<Tag onClick={() => navigateIngress(selectedQuotation?.nim)} className="mr-2 pointer" icon="pi pi-user-edit" severity="warning" value="Recepción"></Tag>
												</Col>
											</Row>
										</Col>
									</div>
								</OverlayPanel>
							</>
					}

					<button
						onClick={() =>
							PreviewQuoter(
								rowData.id_quoter
							)
						}
						className="btnTableAction"
						title='Previsualizar y descargar cotización'
						style={{
							backgroundColor: "#ff6d0b"
						}}
					>
						<i className="fa fa-file-pdf-o"></i>
					</button>


					{
						rowData.id_work_order === null &&
						<button
							onClick={() =>
								handleNavigateSampling(
									rowData.code_quoter
								)
							}
							style={{
								backgroundColor: "#51bb25"
							}}
							className="btnTableAction"
							title='Iniciar Muestreo'

						>
							<i className="icofont icofont-prescription"></i>
						</button>

					}

					{
						rowData.id_work_order !== null &&

						<button
							onClick={() =>
								downdloadpdfSampling(
									rowData.id_quoter,
									rowData.code_quoter
								)
							}
							style={{
								backgroundColor: "#bf0d0d"
							}}
							className="btnTableAction"
							title='Previsualizar y Descargar Hoja de Toma y Custodia'

						>
							<i className="fa fa-file-archive-o"></i>
						</button>


					}
				</div>
			</>
		);
	};

	const headerStyle = {
		backgroundColor: "#1d5b83",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "12px",
		borderRight: "1px solid #fff",
		borderBottom: "2px solid #fff",
	};

	const cellStyle = {
		fontSize: "12px",
		padding: "5px",
		textAlign: "center",
		fontFamily: "Montserrat, sans-serif",

	};

	const centerStyle = {
		...cellStyle,
		textAlign: "center",
	};

	const rowExpansionTemplate = (data) => {

		return (

			<div className="p-2">

				<Table
					className="b-r-5 table table-sm"
					style={{
						borderCollapse: "collapse",
						width: "100%"
					}}
				>

					<thead>

						<tr
							style={{
								backgroundColor: "#033d5b",
								borderBottom: "2px solid #e3ebf3"
							}}
						>
							<th style={{ textAlign: "center", color: "#fff" }}>
								Cantidad
							</th>

							<th style={{ textAlign: "center", color: "#fff" }}>
								Muestra
							</th>

							<th style={{ textAlign: "center", color: "#fff" }}>
								Determinaciones y normas asociadas
							</th>

							<th style={{ textAlign: "center", color: "#fff" }}>
								Estatus de muestra
							</th>

							<th style={{ textAlign: "center", color: "#fff" }}>
								Estudios adicionales
							</th>

						</tr>

					</thead>

					<tbody>

						{data.list_determinations?.map((item, index) => {

							const firstDetermination =
								item.list_determinations?.[0];

							return (

								<tr key={index}>

									<td
										style={{
											textAlign: "center"
										}}
									>
										1
									</td>

									<td
										style={{
											textAlign: "center"
										}}
									>
										{item.name_sample}
									</td>

									<td>

										{
											item.list_determinations?.map(
												(determination, key) => (

													<div
														key={key}
														style={{
															padding: "5px 0"
														}}
													>

														<strong>
															{
																determination.name
															}
														</strong>

														{
															determination.list_nom?.length > 0 &&

															<ul
																style={{
																	listStyle: "none"
																}}
															>

																{
																	determination.list_nom.map(
																		(nom, i) => (

																			<li key={i}>
																				-
																				{" "}
																				{nom.name}
																			</li>

																		)
																	)
																}

															</ul>
														}

													</div>

												)
											)
										}

									</td>

									<td
										style={{
											textAlign: "center"
										}}
									>

										{
											firstDetermination?.not_collected ?

												<Tag
													severity="danger"
													value="Cancelado"
												/>

												:

												firstDetermination?.collected_id === "N/A" ?

													<Tag
														severity="warning"
														value="Pendiente"
													/>

													:

													<Tag
														severity="success"
														value="Recolectado"
													/>
										}

									</td>

									<td
										style={{
											textAlign: "center"
										}}
									>

										{
											item.list_determinations?.map(
												(determination, key) => (

													<div key={key}>

														{
															determination.is_edit === 1 ?

																<i
																	title={`Agregado el día: ${determination.create_at_time}`}
																	className="pi pi-check-circle txt-success"
																/>

																:

																<i
																	className="pi pi-times-circle txt-danger"
																/>
														}

													</div>

												)
											)
										}

									</td>

								</tr>

							);

						})}

					</tbody>

				</Table>

			</div>

		);
	};

	return (
		<DataTable
			value={informationQuatation}
			loading={loadingCreate}
			responsiveLayout="scroll"
			expandedRows={expandedRows}
			onRowToggle={(e) => setExpandedRows(e.data)}
			rowExpansionTemplate={rowExpansionTemplate}
			dataKey="id_quoter"
			paginator
			rows={10}
			rowsPerPageOptions={[10, 50, 100]}
			className="data-table p-datatable-striped p-datatable-sm"
			emptyMessage={
				<div className="text-center">
					<img
						src={require("../../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
						style={{ width: "32%" }}
						alt="Sin resultados"
					/>
					<br />
					<p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
						No se encontraron resultados.
					</p>
				</div>
			}

		>
			<Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />

			<Column expander style={{ width: '3rem' }} />

			<Column
				header="Código"
				body={codeTemplate}
				headerStyle={headerStyle} style={cellStyle}
			/>

			<Column
				header="Tipo"
				body={typeTemplate}
				headerStyle={headerStyle} style={cellStyle}
			/>

			<Column
				header="Cliente"
				body={clientTemplate}
				headerStyle={headerStyle} style={cellStyle}
			/>

			<Column
				header="Fecha"
				body={dateTemplate}
				headerStyle={headerStyle} style={cellStyle}
			/>

			<Column
				header="IVA"
				body={ivaTemplate}
				headerStyle={headerStyle} style={cellStyle}
			/>
			<Column
				header="Muestreo programado"
				body={dateSampling}
				headerStyle={headerStyle} style={cellStyle}
			/>
			<Column
				header="Fecha programada"
				body={dateTemplate2}
				headerStyle={headerStyle} style={cellStyle}
			/>





			<Column
				header="Acciones"
				body={actionsTemplate}
				headerStyle={headerStyle} style={cellStyle}
			/>
		</DataTable>

	)
}
